/**
 * Protected Route Layout
 * Wraps app routes and enforces authentication
 */

import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../features/auth/AuthProvider';
import { AppShell } from '../../components/layout/AppShell';
import { WhatsNewModal } from '../../components/shared/WhatsNewModal';
import { useWhatsNew } from '../../hooks/useWhatsNew';

export function AppLayout() {
  const { isAuthenticated, isLoading } = useAuth();
  const { isOpen, versions, loading, error, closeModal, dismissPermanently } = useWhatsNew();

  // Show loading state
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1DB954] mx-auto mb-4"></div>
          <p className="text-gray-300">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Render app shell with nested routes
  return (
    <>
      <AppShell>
        <Outlet />
      </AppShell>

      {/* What's New modal - shows after login */}
      <WhatsNewModal
        open={isOpen}
        onClose={closeModal}
        onDismiss={dismissPermanently}
        versions={versions}
        loading={loading}
        error={error}
      />
    </>
  );
}
